/* 
These functions make sure WordPress 
and JBST play nice together.
*/

$(document).ready(function() {
    
    // Remove empty P tags created by WP inside of Accordion and Orbit
    //$('.accordion p:empty, .orbit p:empty').remove();
    
		
	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').addClass('embed-responsive-item').wrap("<div class='embed-responsive embed-responsive-16by9'/>");
     
    // offcanvas menu
    $('[data-toggle="offcanvas"]').click(function () {
      $('.row-offcanvas').toggleClass('active');
    });

  $('#menu-item-23 > .nav-link').on('click', function() {
    $(this).toggleClass('highlighted');
  });

  $(".dropdown-menu").hover(function() {
    $(".dropdown-toggle").toggleClass('hovered');
  });

});
